import {Button, Col, Form, Row, Table} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import APIService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";
import {useLocation} from "react-router-dom";
import GenericErrorModal from "../modal/genericErrorModal";

const AdminEditCourse = () => {

    const location = useLocation();
    const [titoloCorso, setTitoloCorso] = useState();
    const [luogoCorso, setLuogoCorso] = useState();
    const [livelloCorso, setLivelloCorso] = useState();
    const [giornoCorso, setGiornoCorso] = useState();
    const [oraInizioCorso, setOraInizioCorso] = useState();
    const [pausaCorso, setPausaCorso] = useState(false);
    const [numeroMassimoPartecipanti, setNumeroMassimoPartecipanti] = useState();
    const [dataInizioVisibilitaShop, setDataInizioVisibilitaShop] = useState();
    const [dataFineVisibilitaShop, setDataFineVisibilitaShop] = useState();
    const [prezzoCorso, setPrezzoCorso] = useState();
    const [durataCorso, setDurataCorso] = useState();
    const [periodo, setPeriodo] = useState("Summer");
    const [giornoData, setGiornoData] = useState([]);
    const [giornoRowData, setGiornoRowData] = useState([]);
    const [levelOptions, setLevelOptions] = useState([]);
    const [piscinaOptions, setPiscinaOptions] = useState([]);
    const [editCourseId, setEditCourseId] = useState();
    // eslint-disable-next-line no-unused-vars
    const [contentErrorCreazioneCorso, setContentErrorCreazioneCorso] = useState({
        state: false,
        title: "",
        body: ""
    });

    useEffect(() => {
        let editCOurseId = location.state?.from

        if(editCOurseId){
            getCourseToEdit(editCOurseId)
        }

        getAvailableLevels();
        getAvailablePlaces();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getCourseToEdit = async (editCOurseId)  =>  {
        let [courseInformation, daysInformation] = await Promise.all([
            APIService.getCourseById(editCOurseId),
            APIService.getDaysForCourse(editCOurseId)
        ])

        setEditCourseId(courseInformation.id)
        setTitoloCorso(courseInformation.title)
        setLuogoCorso(courseInformation.piscinaId)
        setPeriodo(courseInformation.period)
        setDurataCorso(courseInformation.durationInMinutes)
        setLivelloCorso(courseInformation.levelCourseId)
        setNumeroMassimoPartecipanti(courseInformation.maxParticipants)
        setPrezzoCorso(courseInformation.price)
        setDataInizioVisibilitaShop(DateTimeUtils.formatStringAsDate(courseInformation.visibilityStart))
        setDataFineVisibilitaShop(DateTimeUtils.formatStringAsDate(courseInformation.visibilityEnd))

        if(daysInformation.length > 0){
            let daysArray = []
            // eslint-disable-next-line array-callback-return
            daysInformation.map((day, index) => {
                daysArray.push({
                    id: day.id,
                    day: DateTimeUtils.formatStringAsDate(day.day),
                    start: DateTimeUtils.convertUTCToLocalTime(day.start),
                    end: DateTimeUtils.convertUTCToLocalTime(day.end),
                    pause: day.pause,
                    zoneOffset: "+02:00" // DateTimeUtils.getBrowserCurrentTimeZoneOffset()
                })
            })

            setGiornoData(daysArray);
        }

    }

    const getAvailableLevels = () => {
        let items = [];

        items.push(<option key={0}>Seleziona Livello</option>)
        APIService.getLevelList().then((levelObj) => {

            for (let i = 0; i < levelObj.levelCourseDtos.length; i++) {
                let currentLevel = levelObj.levelCourseDtos[i];
                items.push(<option key={currentLevel.id}
                                   value={currentLevel.id}>Livello {currentLevel.level}</option>)
            }

            setLevelOptions(items);
        })
    }

    const getAvailablePlaces = () => {
        let items = [];

        items.push(<option key={0}>Seleziona piscina</option>)
        APIService.getLuogoPiscineList().then(piscineList => {
            for (let i = 0; i< piscineList.piscinaDtos.length; i++){
                let currentPool = piscineList.piscinaDtos[i];
                items.push(<option key={currentPool.id} value={currentPool.id}>{currentPool.title}</option>)
            }

            setPiscinaOptions(items);
        })
    }

    useEffect(() => {

        let giornoRow = []
        giornoData.forEach((item, index, arr) => {
            giornoRow.push(
                <tr>
                    <td>{index + 1}</td>
                    <td>{item.day}</td>
                    <td>{item.data}</td>
                    {item.pause ? <td>Pausa</td> : <td>{item.start}-{item.end}</td>}
                    <td className={'text-end'}>
                        <Button size={'sm'} variant={'primary'}
                                onClick={(e) => handleEliminaFromDays(e, index)}>Elimina</Button>
                    </td>
                </tr>
            )
        })

        setGiornoRowData(giornoRow);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [giornoData])

    const handleAggiuntaGiornoCorso = (e) => {
        e.preventDefault();

        let days = [];
        days.push(...giornoData)

        let date = DateTimeUtils.formatStringAsDate(giornoCorso).split(" ");
        let dayInfo = {
            day: date[0],
            start: (!pausaCorso ? oraInizioCorso : null),
            end: (!pausaCorso ? DateTimeUtils.addMinutesToTime(oraInizioCorso, durataCorso) : null),
            pause: pausaCorso,

            zoneOffset:  "+02:00" // DateTimeUtils.getBrowserCurrentTimeZoneOffset()
        }

        days = days.filter(function (el) {
            return el.day !== dayInfo.day
        })
        days.push(dayInfo)

        setGiornoData(days);
    }

    const handleEliminaFromDays = (e, index) => {
        e.preventDefault();

        if(location.state?.from){
            APIService.deleteDayById(giornoData[index].id).then(response =>{
                setGiornoData(oldData => {
                    return oldData.filter((value, i) => i !== index)
                })
            })
        } else {
            setGiornoData(oldData => {
                return oldData.filter((value, i) => i !== index)
            })
        }
    }

    const handleSalvaCorso = (e) => {
        e.preventDefault();

        let payload = {
            title: titoloCorso,
            piscinaId: parseInt(luogoCorso),
            levelCourseId: parseInt(livelloCorso),
            noOfLessons: parseInt(giornoData.length),
            maxParticipants: parseInt(numeroMassimoPartecipanti),
            visibilityStart: handleDataShopChange(dataInizioVisibilitaShop),
            visibilityEnd: handleDataShopChange(dataFineVisibilitaShop),
            price: parseInt(prezzoCorso),
            durationInMinutes: parseInt(durataCorso),
            period: periodo,
            publishDate: DateTimeUtils.fromTimeMillisToDateTime(Date.now()),
        }

        if(location.state?.from){
            APIService.editAdminCourse(payload, editCourseId)
                .then(resp => {
                    setContentErrorCreazioneCorso({
                        state: true,
                        title: "Corso Modificato correttamente",
                        body: "Continua"
                    })
                })
                .catch(error => {
                    setContentErrorCreazioneCorso({
                        state: true,
                        title: "Errore Modifica Corso",
                        body: "Impossibile completare la richiesta"
                    })
                })
            console.log(JSON.stringify(giornoData))
            let daysToAdd = giornoData.map(item => ({
                ...item,
                courseId: editCourseId
            }));

            daysToAdd = daysToAdd.filter(item => !item.hasOwnProperty('id'))
            console.log(JSON.stringify(daysToAdd))
            APIService.createAdminDaysForCourse(daysToAdd)
        } else {
            APIService.createAdminCourse(payload)
                .then(response => {
                    let daysToAdd = giornoData.map(item => ({
                        ...item,
                        courseId: response.id
                    }));

                    APIService.createAdminDaysForCourse(daysToAdd)
                        .then(res => {
                            setContentErrorCreazioneCorso({
                                state: true,
                                title: "Corso Creato correttamente",
                                body: "Continua"
                            })
                        })
                        .catch(error =>
                            APIService.deleteCourse(response.id)
                                .then(deletion => {
                                    setContentErrorCreazioneCorso({
                                        state: true,
                                        title: "Errore Creazione Corso",
                                        body: "Impossibile completare la richiesta"
                                    })
                                })
                        )

                })
                .catch(errorResponse => {
                    if(errorResponse.status === 409){
                        setContentErrorCreazioneCorso({
                            state: true,
                            title: "Errore Creazione Corso",
                            body: "Il corso risulta già registrato"
                        })
                    }
                })
        }
    }

    function handleDataShopChange(date) {
        const fixedTime = '00:00'; // Fixed time of "00:00"

        const datetime = `${date} ${fixedTime}`;
        const customDate = new Date(datetime);
        console.log(customDate.toISOString())
        return customDate.toISOString() // Output: 2023-07-05T00:00:00.000Z
    }

    const handleCloseErrorModal = () => setContentErrorCreazioneCorso({
        state: false,
        title: "",
        body: ""
    })

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>
                    <Row className={'justify-content-between'}>
                        <Col>
                            <div className={'title-page-section mt-5 mb-5'}>
                                <h2 className={'title'}>{location.state?.from ? "Modifica Corso" : "Nuovo Corso"}</h2>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Form>
                    <Col xs={12} lg={6}>

                        <Form.Group className="mb-4">
                            <Form.Label>Titolo</Form.Label>
                            <Form.Control type='text'  placeholder="titolo" value={titoloCorso} onChange={(e) => setTitoloCorso(e.target.value)}/>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Luogo</Form.Label>
                            <Form.Select value={luogoCorso} onChange={(e) => setLuogoCorso(e.target.value)}>
                                {piscinaOptions}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Periodo</Form.Label>
                            <Form.Select value={periodo} onChange={(e) => setPeriodo(e.target.value)}>
                                <option value="Summer">Estivi</option>
                                <option value="Winter">Invernali</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Durata Lezioni in Minuti</Form.Label>
                            <Form.Control type='number' value={durataCorso} onWheel={ event => event.currentTarget.blur()} min={0} onChange={(e) => setDurataCorso(e.target.value)} placeholder="0"/>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Livello</Form.Label>
                            <Form.Select value={livelloCorso} onChange={(e) => setLivelloCorso(e.target.value)}>
                                {levelOptions}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={12} lg={7}>
                        <Row>
                            <Col xs={12} sm={6} md={'auto'}>
                                <Form.Group className="mb-4">
                                    <Form.Label>Giorno</Form.Label>
                                    <Form.Control type='date' onChange={(e) => setGiornoCorso(e.target.value)}
                                                  placeholder="giorno"/>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={'auto'}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-4">
                                            <Form.Label>Orario inizio</Form.Label>
                                            <Form.Control type='time' disabled={pausaCorso}
                                                          onChange={(e) => setOraInizioCorso(e.target.value)}
                                                          placeholder="ora"/>
                                        </Form.Group>
                                    </Col>

                                </Row>
                            </Col>
                            <Col>
                                <Form.Group className="mb-4">
                                    <Form.Label>Pausa</Form.Label>
                                    <Form.Check
                                        type="checkbox"
                                        onChange={(e) => setPausaCorso(!pausaCorso)}
                                        id="pause-switch"
                                        label="Seleziona se giorno di pausa"
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={'auto'}>
                                <Button variant={'primary'}
                                        disabled={(giornoCorso === undefined || giornoCorso === ""
                                            || oraInizioCorso === undefined || oraInizioCorso === "")}
                                        size={'sm'} onClick={(e) => handleAggiuntaGiornoCorso(e)}
                                        className={'mt-4'}>Aggiungi</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Table striped hover>
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Giorno</th>
                                        <th>Data</th>
                                        <th>Orario</th>
                                        <th className={'text-end'}></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {giornoRowData.length > 0 && giornoRowData}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Col>

                    <Col xs={12} lg={6}>
                        <Form.Group className="mb-4">
                            <Form.Label>Numero massimo partecipanti</Form.Label>
                            <Form.Control type='number' value={numeroMassimoPartecipanti} onWheel={ event => event.currentTarget.blur()} onChange={(e) => setNumeroMassimoPartecipanti(e.target.value)} placeholder="0"/>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Prezzo</Form.Label>
                            <Form.Control type='number' value={prezzoCorso} onWheel={ event => event.currentTarget.blur()} onChange={(e) => setPrezzoCorso(e.target.value)} placeholder="0"/>
                        </Form.Group>

                        <Row>
                            <Col>
                                <Form.Group className="mb-4">
                                    <Form.Label>Data inizio visibilità sullo shop</Form.Label>
                                    <Form.Control type='date' value={dataInizioVisibilitaShop} onChange={(e) => setDataInizioVisibilitaShop(e.target.value)} placeholder="giorno"/>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-4">
                                    <Form.Label>Data fine visibilità sullo shop</Form.Label>
                                    <Form.Control type='date' value={dataFineVisibilitaShop} onChange={(e) => setDataFineVisibilitaShop(e.target.value)} placeholder="giorno"/>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Row className={'justify-content-end'}>
                            <Col xs={'auto'}>
                                <Button variant={'primary'} onClick={(e) => handleSalvaCorso(e)}
                                        className={'mb-5 px-5 fw-bold text-uppercase'}>Salva</Button>
                            </Col>
                        </Row>
                    </Col>
                </Form>
            </Row>

            <GenericErrorModal handleClose={handleCloseErrorModal} contentText={contentErrorCreazioneCorso} showModal={contentErrorCreazioneCorso.state}/>

        </>

    );
}

export default AdminEditCourse;
